<div>
  <h4 style="">Buyer choice</h4>
  <div *ngIf="property.buyerChoice" style="position: relative">
    <div class="choice">
      <div class="label">What color scheme does the buyer need?</div>
      <div>{{property.buyerChoice.colorScheme === 1 ? 'Light' : 'Dark'}}</div>
    </div>
    <div class="choice">
      <div class="label">Does the buyer need mobile bench?</div>
      <div>{{property.buyerChoice.mobileBenchOption === 1 ? 'Yes' : 'No'}}</div>
    </div>
    <div class="choice">
      <div class="label">Which does the buyer need, dish washer or dish drawer?</div>
      <div>{{property.buyerChoice.dishAccessory === 1 ? 'Dish washer' : 'Dish drawer'}}</div>
    </div>
    <div matTooltip="Delete" (click)="openDeleteBuyerChoiceDialog(property.buyerChoice)"
      style="position: absolute; right: 20px; top: calc(50% - 10px); cursor: pointer; padding: 8px; border-radius: 50%; display: flex; justify-content: center; align-items: center; background: #c8c8c8">
      <img src="./assets/images/delete_buyer.svg" style="width: 15px; height: 15px">
    </div>
  </div>
  <button mat-button *ngIf="!property.buyerChoice" (click)="openCreateBuyerChoiceDialog()"
    style="background: #161616; margin-left: 10px;border: 1px solid #DEDEDE; width: 163px;height: 52px;color: #DEDEDE;">
    Add buyer choice
  </button>
</div>